module.exports = __webpack_public_path__ + "static/media/watermark.abc4dd97.png";